export default function PaymentSourceServiceProvider() {
  this.$get = () => {
    'ngInject';

    function PaymentSourceService() {

      const self = this;

      const BRANDS = {
        'visa': {icon: require('/assets/img/payment/visa.svg'), label: 'Visa'},
        'maestro': {icon: require('/assets/img/payment/maestro.svg'), label: 'Maestro'},
        'visaelectron': {icon: require('/assets/img/payment/visa.svg'), label: 'Visa Electron'},
        'visa electron': {icon: require('/assets/img/payment/visa.svg'), label: 'Visa Electron'},
        'visamaster': {icon: require('/assets/img/payment/visa.svg'), label: 'Visa Master'},
        'mastercard': {icon: require('/assets/img/payment/mastercard.svg'), label: 'MasterCard'},
        'amex': {icon: require('/assets/img/payment/amex.svg'), label: 'Amex'},
        'americanexpress': {icon: require('/assets/img/payment/amex.svg'), label: 'Amex'},
        'american express': {icon: require('/assets/img/payment/amex.svg'), label: 'Amex'},
        'bcglobal': {icon: require('/assets/img/payment/amex.svg'), label: 'BCGlobal'},
        'discover': {icon: require('/assets/img/payment/discover.svg'), label: 'Discover'},
        'dinersclub': {icon: require('/assets/img/payment/diners-club.svg'), label: 'DinersClub'},
        'diners club': {icon: require('/assets/img/payment/diners-club.svg'), label: 'DinersClub'},
        'jcb': {icon: require('/assets/img/payment/jcb.svg'), label: 'JCB'},
        'carteblanche': {icon: require('/assets/img/payment/stripe.svg'), label: 'CarteBlanche'},
        'instapayment': {icon: require('/assets/img/payment/stripe.svg'), label: 'InstaPayment'},
        'koreanlocal': {icon: require('/assets/img/payment/stripe.svg'), label: 'KoreanLocal'},
        'laser': {icon: require('/assets/img/payment/stripe.svg'), label: 'Laser'},
        'solo': {icon: require('/assets/img/payment/stripe.svg'), label: 'Solo'},
        'switch': {icon: require('/assets/img/payment/stripe.svg'), label: 'Switch'},
        'unionpay': {icon: require('/assets/img/payment/stripe.svg'), label: 'UnionPay'},
        'velotooler': {icon: require('/assets/img/payment/velotooler.svg'), label: 'Velotooler'},
        'unknown': {icon: require('/assets/img/payment/stripe.svg'), label: 'Unknown Brand'}
      }

      const defaultFormat = /(\d{1,4})/g;

      const cards = [
        {
          type: 'maestro',
          pattern: /^(5(018|0[23]|[68])|6(39|7))/,
          format: defaultFormat,
          length: [12, 13, 14, 15, 16, 17, 18, 19],
          cvcLength: [3],
          luhn: true
        },
        {
          type: 'mastercard',
          pattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)/,
          format: defaultFormat,
          length: [16],
          cvcLength: [3],
          luhn: true
        }, {
          type: 'amex',
          pattern: /^3[47]/,
          format: defaultFormat,
          length: [15],
          cvcLength: [3, 4],
          luhn: true
        }, {
          type: 'visa',
          pattern: /^4/,
          format: defaultFormat,
          length: [13, 14, 15, 16],
          cvcLength: [3],
          luhn: true
        }, {
          type: 'visaelectron',
          pattern: /^4(026|17500|405|508|844|91[37])/,
          format: defaultFormat,
          length: [16],
          cvcLength: [3],
          luhn: true
        }, {
          type: 'discover',
          pattern: /^6(44|45|46|47|48|49|22|5|011)/,
          format: defaultFormat,
          length: [16],
          cvcLength: [3],
          luhn: true
        }, {
          type: 'dinersclub',
          pattern: /^(3(0[0-5])|54|36|38)/,
          format: defaultFormat,
          length: [14],
          cvcLength: [3],
          luhn: true
        }, {
          type: 'jcb',
          pattern: /^(2131|1800|35)/,
          format: defaultFormat,
          length: [15, 16],
          cvcLength: [3],
          luhn: true
        }
      ];

      self.getDetails = brand => {
        if (brand) {
          return BRANDS[brand.toLowerCase()] || BRANDS['unknown'];
        } else {
          return BRANDS['unknown'];
        }
      }

      self.expiryDateFormat = date => {
        const expiryDate = date.split("-");
        return expiryDate[1] + '/' + expiryDate[0].replace('20', '');
      }

      self.parseCardNumber = details => {
        const result = {};
        result.last4 = details.replaceAll(' ', '').replaceAll('•', '');
        result.dots = []
        const dots = details.replace(result.last4, "");
        dots.split(' ')
          .filter(group => group !== '')
          .forEach(group => result.dots.push(group.split('')));
        return result;
      }

      self.prepareCardToView = item => {
        if (item && item.brand) {
          const cardDetails = self.getDetails(item.brand);
          item.icon = cardDetails.icon;
          item.label = cardDetails.label;

          if (item.brand.toLowerCase() === 'velotooler') {
            item.vtWallet = true;
          } else {
            item.date = self.expiryDateFormat(item.expiryDate);

            const cardNumber = self.parseCardNumber(item.details);
            item.last4 = cardNumber.last4;
            item.dots = cardNumber.dots;
          }
        }
      }

      self.mergeWithBalance = (sources, balance) => {
        const merged = [];
        if (balance && (balance.amount !== 0 || balance.creditLimit !== 0)) {
          merged.push(balance);
        }
        if (sources) {
          sources.forEach(source => merged.push(source));
        }
        return merged;
      };

      self.trim = str => str.toString().replace(/^\s+|\s+$/g, '');

      self.formatCardName = name => {
        name = name.replace(/[^A-Za-z\s-\\.]/g, '');
        name = name.replace(/\s(?=\s)/g, ''); /* Delete double spaces */
        name = name.replace(/^\s+/, ''); /* Delete first spaces */
        name = name.replace(/^-+/, ''); /* Delete first hyphens */
        name = name.replace(/-(?=-)/g, ''); /* Delete double hyphens */
        name = name.replace(/^\.+/, ''); /* Delete first dots */
        name = name.replace(/\.(?=\.)/g, ''); /* Delete double dots */

        return name.toUpperCase().substr(0, 22);
      };

      self.validateCardName = name => {
        if (!name) {
          return false;
        }

        if (!/[^A-Z]/g.test(name)) {
          return false;
        }

        return name.length >= 3;
      };

      self.cardFromNumber = num => {
        if (!num) {
          return null;
        }

        num = num.toString().replace(/\W/g, '');
        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          if (card.pattern.test(num)) {
            return card;
          }
        }

        return null;
      };

      self.luhnCheck = num => {
        const digits = num.toString().split('').reverse();
        let sum = 0;
        let odd = true;

        for (let i = 0; i < digits.length; i++) {
          let digit = digits[i];
          digit = parseInt(digit, 10);

          if ((odd = !odd)) {
            digit *= 2;
          }

          if (digit > 9) {
            digit -= 9;
          }

          sum += digit;
        }

        return sum % 10 === 0;
      };

      self.validateCardNumber = str => {
        if (!str) {
          return false;
        }

        const number = str.toString().replace(/\s+|-/g, '');
        if (!/^\d+$/.test(number)) {
          return false;
        }

        const card = self.cardFromNumber(number);

        return card ? (card.length.indexOf(number.length) >= 0) && (card.luhn === false || self.luhnCheck(number)) : false;
      };

      self.formatCardNumber = num => {
        if (!num) {
          return;
        }

        num = num.replace(/\D/g, '');
        const card = self.cardFromNumber(num);
        if (!card) {
          let length = num.length;
          num = num.split('');

          //Add separator
          if (length > 4) {
            num.splice(4, 0, ' ');
            length++;
          }
          if (length > 9) {
            num.splice(9, 0, ' ');
            length++;
          }
          if (length > 14) {
            num.splice(14, 0, ' ');
            length++;
          }
          if (length > 19) {
            num.splice(19, 0, ' ');
          }

          return num.join('').substr(0, 19);
        }

        const upperLength = card.length[card.length.length - 1];

        num = num.slice(0, +upperLength || 9e9);

        if (card.format.global) {
          const ref = num.match(card.format);
          return ref !== null ? ref.join(' ') : undefined;
        } else {
          const groups = card.format.exec(num);
          if (groups !== null) {
            groups.shift();
          }
          return groups !== null ? groups.join(' ') : undefined;
        }
      };

      self.validateCardExpiry = (month, year) => {
        if (typeof month === 'object' && month.hasOwnProperty('month')) {
          year = month.year;
          month = month.month;
        }

        if (!(month && year)) {
          return false;
        }

        month = self.trim(month);
        year = self.trim(year);

        if (!/^\d+$/.test(month)) {
          return false;
        }

        if (!/^\d+$/.test(year)) {
          return false;
        }

        if (parseInt(month, 10) > 12) {
          return false;
        }

        if (year.length === 2) {
          const fullYear = (new Date()).getFullYear();
          const prefix = fullYear.toString().slice(0, 2);
          year = prefix + year;
        }

        const expiry = new Date(year, month);
        const currentTime = new Date();
        expiry.setMonth(expiry.getMonth() - 1);
        expiry.setMonth(expiry.getMonth() + 1, 1);

        return expiry > currentTime;
      };

      self.cardFromType = type => {
        for (let i = 0; i < cards.length; i++) {
          if (cards[i].type === type) {
            return cards[i];
          }
        }

        return undefined;
      };

      self.validateCardCVC = (rowCvc, type) => {
        const cvc = self.trim(rowCvc);

        if (!/^\d+$/.test(cvc)) {
          return false;
        }

        if (type) {
          const card = self.cardFromType(type);
          return card ? card.cvcLength.indexOf(cvc.length) >= 0 : false;
        }

        return cvc.length >= 3 && cvc.length <= 4;
      };

    }

    return new PaymentSourceService();
  };
}